const translations = {
	en: {
		translation: {
			'Saleitem.department': 'Departments',
			'Saleitem.category': 'Categories',
			'Saleitem.name': 'Product Names',
			'Saleitem Units Sold': 'Units Sold',
			'Sale Count': 'Count',
			'Saleitem Revenue': 'Revenue',
			'Sale Time Converted': 'Sale Time',
			//'Comparing Saleitem Revenue': 'Comparision Revenue',
			'Saleitem Gross Profit': 'Gross Profit',
			//'Comparing Saleitem Gross Profit': 'Comparision Gross Profit',
			'Sale Avg Transaction Value': 'Average Sale Value'
		},
	},
};

export default translations;